import {
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  MenuItem,
  Select,
} from "@material-ui/core";
import { Typography } from "@mui/material";
import { Calendar, FilmSlate, Hourglass, ListChecks, X } from "phosphor-react";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { fget } from "../../../../API/callsAPI";
import DateAndTimeViewer from "../../../Utilities/DateAndTimeViewer/DateAndTimeViewer.component";
import Loader from "../../../Utilities/Loader/Loader";
import ChitranSvg from "../../../Utilities/Svg/ChitranSvg";
import TaskToDos from "../../../Utilities/TaskToDos/TaskToDos";
import UsersViewer from "../../../Utilities/UsersViewer/UsersViewer";
import useStyles from "./WidgetsModalsStyles";

const TodoExpandedViewModal = ({ handleClose, projectId }) => {
  const classes = useStyles();
  const history = useHistory();
  const [usersList, setUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState("ALL");
  const [ordering, setOrdering] = useState("priority");
  const [selectedTask, setSelectedTask] = useState({});
  const [showMyTaskFilter, setShowMyTaskFilter] = useState(1);
  const [currentTab, setCurrentTab] = useState("active");
  const [refreshCheckList, setRefreshCheckList] = useState(0);
  const [checkList, setCheckList] = useState([]);
  const [isCheckListLoading, setIsCheckListLoading] = useState(true);

  const updateRefreshChecklist = () => {
    setRefreshCheckList(refreshCheckList + 1);
  };

  const getChecklist = async (loader) => {
    try {
      loader && setIsCheckListLoading(true);
      const res = await fget({
        url: `trackables/checklist/?project=${projectId}&completed=${
          currentTab === "active" ? "False" : "True"
        }&ordering=${ordering}${
          showMyTaskFilter === "1"
            ? "&assigned=1"
            : `${selectedUser !== "ALL" ? `&user=${selectedUser}` : ""}`
        }`,
      });
      setCheckList(res.data.results);
      setSelectedTask(res.data.results[0].task);
      setIsCheckListLoading(false);
    } catch (error) {
      console.log(error);
      setIsCheckListLoading(false);
    }
  };

  const fetchUsers = async () => {
    try {
      const usersRes = await fget({
        url: `project/${projectId}/users/`,
      });
      setUsersList(usersRes.data.results);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  useEffect(() => {
    getChecklist("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    refreshCheckList,
    currentTab,
    projectId,
    ordering,
    showMyTaskFilter,
    selectedUser,
  ]);

  return (
    <div className={classes.todoModalRoot}>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <div className={classes.spaceBetween}>
            <div
              className={classes.flexAndGap4px}
              style={{
                gap: "10px",
              }}
            >
              <ListChecks size={22} />
              <span
                style={{
                  fontSize: "18px",
                }}
              >
                To Do's
              </span>
              <Button startIcon={<Hourglass />}>Planner</Button>
              {/* <Button disabled startIcon={<ChartLineUp />}>
                Analytics
              </Button> */}
            </div>
            <div>
              <Button onClick={handleClose}>
                <X size={30} />
              </Button>
            </div>
          </div>
          <Divider
            style={{
              marginTop: "6px",
            }}
          />
          <div
            className={classes.flexAndGap4px}
            style={{
              marginTop: "6px",
              gap: "16px",
            }}
          >
            <div>
              <span className={classes.grayText}>Filter By</span>
            </div>

            <div className={classes.cardContentDiv2}>
              <Select
                style={{ width: "200px" }}
                labelId="demo-simple-select-outlined-label"
                id="my tasks"
                disableUnderline
                className={classes.cardContentInput1}
                label="Select Task Template"
                value={showMyTaskFilter}
                onChange={(e) => setShowMyTaskFilter(e.target.value)}
                name="department"
              >
                <MenuItem value="0">All Tasks</MenuItem>
                <MenuItem value="1">Only My Task</MenuItem>
              </Select>
            </div>
            {showMyTaskFilter === "0" ? (
              <div className={classes.cardContentDiv2}>
                <Select
                  style={{ width: "200px" }}
                  labelId="demo-simple-select-outlined-label"
                  id="my tasks"
                  disableUnderline
                  className={classes.cardContentInput1}
                  label="Select Task Template"
                  value={selectedUser}
                  onChange={(e) => setSelectedUser(e.target.value)}
                  name="department"
                >
                  <MenuItem value="ALL">All User</MenuItem>
                  {usersList.map((user) => (
                    <MenuItem value={user?.id}>
                      {user?.first_name} {user?.last_name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            ) : (
              ""
            )}
            <div>
              <span className={classes.grayText}>Sort By</span>
            </div>
            <div className={classes.cardContentDiv2}>
              <Select
                style={{ width: "200px" }}
                labelId="demo-simple-select-outlined-label"
                id="my tasks"
                disableUnderline
                className={classes.cardContentInput1}
                label="Select Task Template"
                value={ordering}
                onChange={(e) => setOrdering(e.target.value)}
                name="department"
              >
                <MenuItem value="items">Todo Count</MenuItem>
                <MenuItem value="priority">Priority</MenuItem>
              </Select>
            </div>
          </div>
          {!isCheckListLoading ? (
            <>
              {checkList?.length ? (
                <Grid container spacing={2}>
                  <Grid item md={6}>
                    <div className={classes.taskCardsContainer}>
                      {checkList?.map((singleChecklistItem) => {
                        // Parse the end date using Date.parse() to ensure compatibility
                        const endDate = new Date(
                          Date.parse(singleChecklistItem?.task?.end_time)
                        );
                        const currentDate = new Date();

                        // Calculate the difference in time
                        const differenceInTime = endDate - currentDate;

                        // Convert difference from milliseconds to days
                        const differenceInDays = Math.ceil(
                          differenceInTime / (1000 * 60 * 60 * 24)
                        );

                        return (
                          <div
                            className={
                              selectedTask?.id === singleChecklistItem?.task?.id
                                ? classes.singleTaskCardSelected
                                : classes.singleTaskCard
                            }
                            onClick={() => setSelectedTask(singleChecklistItem)}
                            key={singleChecklistItem?.task?.id}
                          >
                            <div className={classes.spaceBetween}>
                              <div className={classes.flexAndGap4px}>
                                <span
                                  className={classes.statusColor}
                                  style={{
                                    backgroundColor: `rgb(${singleChecklistItem?.task?.status?.color})`,
                                  }}
                                />
                                <span>{singleChecklistItem?.task?.name}</span>
                              </div>
                              <div className={classes.flexAndGap4px}>
                                <ListChecks />
                                <span>
                                  {singleChecklistItem?.checklist_items
                                    ?.length ?? 0}
                                </span>
                              </div>
                            </div>
                            <div className={classes.spaceBetween}>
                              <div className={classes.flexAndGap4px}>
                                <FilmSlate />
                                <span>
                                  {singleChecklistItem?.task?.linked?.name ??
                                    singleChecklistItem?.task?.linked?.code}
                                </span>
                              </div>
                              <div className={classes.flexAndGap4px}>
                                {/* <span>user viewer</span> */}
                                {singleChecklistItem?.task?.assigned_users
                                  ?.length > 0 ? (
                                  <UsersViewer
                                    assignedUser={
                                      singleChecklistItem?.task?.assigned_users
                                    }
                                    selectedTask={singleChecklistItem}
                                    editable="no"
                                  />
                                ) : (
                                  "No user"
                                )}
                              </div>
                            </div>
                            <div className={classes.spaceBetween}>
                              <div className={classes.flexAndGap4px}>
                                <Calendar />
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  {singleChecklistItem?.task?.start_time ? (
                                    <DateAndTimeViewer
                                      dateAndTime={
                                        singleChecklistItem?.task?.start_time
                                      }
                                    />
                                  ) : (
                                    "--"
                                  )}
                                  <span>-</span>
                                  {singleChecklistItem?.task?.end_time ? (
                                    <DateAndTimeViewer
                                      dateAndTime={
                                        singleChecklistItem?.task?.end_time
                                      }
                                    />
                                  ) : (
                                    "--"
                                  )}
                                </div>
                              </div>
                              <div>
                                {singleChecklistItem?.task?.end_time ? (
                                  <span
                                    style={{
                                      color:
                                        differenceInDays < 0 ? "red" : "white",
                                    }}
                                  >
                                    {differenceInDays < 0
                                      ? `${Math.abs(
                                          differenceInDays
                                        )} days Delayed`
                                      : `${differenceInDays} days remaining`}
                                  </span>
                                ) : (
                                  "--"
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <div className={classes.todoListContainer}>
                      {selectedTask?.name ? (
                        <div className={classes.spaceBetween}>
                          <div className={classes.flexAndGap4px}>
                            <span
                              className={classes.statusColor}
                              style={{
                                backgroundColor: `rgb(${selectedTask?.status?.color})`,
                              }}
                            />
                            <span>{selectedTask?.name}</span>
                          </div>
                          <Button
                            onClick={() => history.push(`/${projectId}/tasks`)}
                          >
                            Go To Task
                          </Button>
                        </div>
                      ) : (
                        ""
                      )}
                      <div
                        style={{
                          height: "535px",
                          overflowY: "auto",
                          paddingRight: "10px",
                        }}
                      >
                        <TaskToDos
                          currentTab={currentTab}
                          onChangeTab={setCurrentTab}
                          linkedTask={selectedTask}
                          toDoType="taskPage"
                          updateRefreshChecklist={updateRefreshChecklist}
                          checkList={checkList?.find(
                            (item) => item?.task?.id === selectedTask?.id
                          )}
                          isDataLoading={isCheckListLoading}
                          isTaskDetailsExpanded={true}
                          projectId={projectId}
                        />
                      </div>
                    </div>
                  </Grid>
                </Grid>
              ) : (
                <div
                  style={{
                    height: "500px",
                    // overflowY: "auto",
                    paddingRight: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <ChitranSvg height={200} />
                  <Typography>No Tasks Found</Typography>
                </div>
              )}
            </>
          ) : (
            <Loader />
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default TodoExpandedViewModal;
